<template>
  <vue-number
    v-model="localValue"
    v-bind="numberSetting">
  </vue-number>
</template>

<script>
import { component as VueNumber } from '@coders-tm/vue-number-format'

export default {
  name: 'VueNum',

  components: {
    VueNumber,
  },

  props: {
    value: {
      type: [String, Number],
      default: 0,
    },

    prefix: {
      type: String,
      default: 'Rp ',
    },
  },

  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },

    numberSetting() {
      return {
        decimal: ',',
        separator: '.',
        prefix: this.prefix,
        precision: 0,
        masked: false,
      }
    },
  },
}
</script>